import { useQuery } from "react-query";
import { getConfig } from "../api/config";
import { useEffect, useState } from "react";
import { acquireUserDetails } from "../auth/authUtil";

export const useInitizeAppState = () => {
  const [appState, setAppState] = useState<null | any>({});

  const { data: config } = useQuery({
    queryKey: "config",
    queryFn: getConfig,
    staleTime: Infinity,
  });

  const init = async () => {
    let state = {};
    const user = await acquireUserDetails();
    state = { user, config };
    setAppState(state);
  };

  useEffect(() => {
    if (localStorage.getItem("token")) {
      init();
    }
  }, [config]);

  return [appState, setAppState];
};
